import Layout from '../components/Layouts/Layout.vue'

// GeneralViews
import NotFound from '../components/Layouts/NotFoundPage.vue'

// Pages
import Homepage from 'src/views/homepage/homepage.vue'
import SelectLocation from 'src/views/homepage/select-location-popup.vue'
import Menu from 'src/views/menu/menu.vue'
import LunchBoxes from 'src/views/lunch-boxes/lunch-boxes.vue'
import Contact from 'src/views/contact/contact.vue'
import Checkout from '../views/checkout/checkout.vue'
import CheckoutResponse from '../views/checkout/response.vue'
import Profile from '../views/profile/profile.vue'
import RestorePassword from '../views/profile/restore-password.vue'
import SetPassword from '../views/profile/set-password.vue'

let defaultMetaTags = [
  {
    name: 'description',
    content: 'The Local Chinese Takeaway in the City of London, Clerkenwell and Liverpool Street.'
  },
  {
    property: 'og:type',
    content: 'website'
  },
  {
    property: 'og:description',
    content: 'The Local Chinese Takeaway in the City of London, Clerkenwell and Liverpool Street.'
  },
  {
    property: 'og:image',
    content: 'https://api.kungfood.co.uk/img/kungfood.png'
  },
  {
    property: 'twitter:card',
    content: 'summary'
  },
  {
    property: 'twitter:description',
    content: 'The Local Chinese Takeaway in the City of London, Clerkenwell and Liverpool Street.'
  },
  {
    property: 'twitter:image',
    content: 'https://api.kungfood.co.uk/img/kungfood.png'
  }
]

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'homepage',
        component: Homepage,
        meta: {
          title: 'Kung Food Chinese Takeaway',
          metaTags: defaultMetaTags.concat(
            {
              property: 'og:title',
              content: 'Kung Food Chinese Takeaway'
            },
            {
              property: 'og:url',
              content: 'https://kungfood.co.uk/'
            },
            {
              property: 'twitter:title',
              content: 'Kung Food Chinese Takeaway'
            },
            {
              property: 'twitter:url',
              content: 'https://kungfood.co.uk/'
            }
          )
        },
        children: [
          {
            path: 'select-location',
            name: 'select-location',
            component: SelectLocation,
            meta: {
              title: 'Select Location - Kung Food Chinese Takeaway',
              metaTags: defaultMetaTags.concat(
                {
                  property: 'og:title',
                  content: 'Select Location - Kung Food Chinese Takeaway'
                },
                {
                  property: 'og:url',
                  content: 'https://kungfood.co.uk/select-location'
                },
                {
                  property: 'twitter:title',
                  content: 'Select Location - Kung Food Chinese Takeaway'
                },
                {
                  property: 'twitter:url',
                  content: 'https://kungfood.co.uk/select-location'
                }
              )
            }
          }
        ]
      },
      {
        path: 'profile',
        name: 'profile',
        component: Profile,
        meta: {
          title: 'Profile - Kung Food Chinese Takeaway',
          metaTags: defaultMetaTags.concat(
            {
              property: 'og:title',
              content: 'Profile - Kung Food Chinese Takeaway'
            },
            {
              property: 'og:url',
              content: 'https://kungfood.co.uk/profile'
            },
            {
              property: 'twitter:title',
              content: 'Profile - Kung Food Chinese Takeaway'
            },
            {
              property: 'twitter:url',
              content: 'https://kungfood.co.uk/profile'
            }
          )
        }
      },
      {
        path: 'restore-password',
        name: 'restore-password',
        component: RestorePassword,
        meta: {
          title: 'Restore Password - Kung Food Chinese Takeaway',
          metaTags: defaultMetaTags.concat(
            {
              property: 'og:title',
              content: 'Restore Password - Kung Food Chinese Takeaway'
            },
            {
              property: 'og:url',
              content: 'https://kungfood.co.uk/restore-password'
            },
            {
              property: 'twitter:title',
              content: 'Restore Password - Kung Food Chinese Takeaway'
            },
            {
              property: 'twitter:url',
              content: 'https://kungfood.co.uk/restore-password'
            }
          )
        }
      },
      {
        path: 'set-password/:passwordToken',
        name: 'set-password',
        component: SetPassword,
        meta: {
          title: 'Set Password - Kung Food Chinese Takeaway',
          metaTags: defaultMetaTags.concat(
            {
              property: 'og:title',
              content: 'Set Password - Kung Food Chinese Takeaway'
            },
            {
              property: 'og:url',
              content: 'https://kungfood.co.uk/set-password'
            },
            {
              property: 'twitter:title',
              content: 'Set Password - Kung Food Chinese Takeaway'
            },
            {
              property: 'twitter:url',
              content: 'https://kungfood.co.uk/set-password'
            }
          )
        },
        props: route => ({
          passwordToken: route.params.passwordToken
        })
      },
      {
        path: 'menu',
        name: 'menu',
        component: Menu,
        meta: {
          title: 'Menu - Kung Food Chinese Takeaway',
          metaTags: defaultMetaTags.concat(
            {
              property: 'og:title',
              content: 'Menu - Kung Food Chinese Takeaway'
            },
            {
              property: 'og:url',
              content: 'https://kungfood.co.uk/menu'
            },
            {
              property: 'twitter:title',
              content: 'Menu - Kung Food Chinese Takeaway'
            },
            {
              property: 'twitter:url',
              content: 'https://kungfood.co.uk/menu'
            }
          )
        }
      },
      {
        path: 'lunch-boxes',
        name: 'lunchBoxes',
        component: LunchBoxes,
        meta: {
          title: 'Lunch Boxes - Kung Food Chinese Takeaway',
          metaTags: defaultMetaTags.concat(
            {
              property: 'og:title',
              content: 'Lunch Boxes - Kung Food Chinese Takeaway'
            },
            {
              property: 'og:url',
              content: 'https://kungfood.co.uk/lunch-boxes'
            },
            {
              property: 'twitter:title',
              content: 'Lunch Boxes - Kung Food Chinese Takeaway'
            },
            {
              property: 'twitter:url',
              content: 'https://kungfood.co.uk/lunch-boxes'
            }
          )
        }
      },
      {
        path: 'contact',
        name: 'contact',
        component: Contact,
        meta: {
          title: 'Contact - Kung Food Chinese Takeaway',
          metaTags: defaultMetaTags.concat(
            {
              property: 'og:title',
              content: 'Contact - Kung Food Chinese Takeaway'
            },
            {
              property: 'og:url',
              content: 'https://kungfood.co.uk/contact'
            },
            {
              property: 'twitter:title',
              content: 'Contact - Kung Food Chinese Takeaway'
            },
            {
              property: 'twitter:url',
              content: 'https://kungfood.co.uk/contact'
            }
          )
        }
      },
      {
        path: 'checkout',
        name: 'checkout',
        component: Checkout,
        meta: {
          title: 'Checkout - Kung Food Chinese Takeaway',
          metaTags: defaultMetaTags.concat(
            {
              property: 'og:title',
              content: 'Checkout - Kung Food Chinese Takeaway'
            },
            {
              property: 'og:url',
              content: 'https://kungfood.co.uk/checkout'
            },
            {
              property: 'twitter:title',
              content: 'Checkout - Kung Food Chinese Takeaway'
            },
            {
              property: 'twitter:url',
              content: 'https://kungfood.co.uk/checkout'
            }
          )
        }
      },
      {
        path: 'checkout-response',
        name: 'checkout-response',
        component: CheckoutResponse,
        props: true,
        meta: {
          title: 'Checkout Response - Kung Food Chinese Takeaway',
          metaTags: defaultMetaTags
        }
      }
    ]
  },
  {
    path: '*',
    component: NotFound,
    meta: {
      title: 'Page Not Found - Kung Food Chinese Takeaway',
      metaTags: defaultMetaTags.concat(
        {
          property: 'og:title',
          content: 'Page Not Found - Kung Food Chinese Takeaway'
        },
        {
          property: 'twitter:title',
          content: 'Page Not Found - Kung Food Chinese Takeaway'
        }
      )
    }
  }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/index.js